import React, { createContext, useMemo, useReducer, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import BannerImage from "../../assets/images/store-banner.png";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./index.module.css";
import { Outlet, useNavigate } from "react-router-dom";
import Nav from "../../components/Nav";
import Breadcrumb, { BreadcrumbContext } from "../../components/Breadcrumb";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

function reducer(state = { links: [], title: '' }, action) {
  switch (action.type) {
    case "SET_BREADCRUMB":
      return { ...action.payload };

    default:
      return state;
  }
}


function TopNavContainer(props) {
  const [state, dispatch] = useReducer(reducer, { links: [], title: '' });
  const navigate = useNavigate();
  
  return (
    <BreadcrumbContext.Provider value={[state, dispatch]}>
      <Stack className={styles.landingPage} component="main" direction="column">
        <Stack className={styles.mainSection}>
          <Box className={styles.heroBanner}>
            <img src={BannerImage} alt="hero-banner" />
          </Box>
          <Box className={styles.content}>
            <Stack
              direction="row"
              spacing={1}
              sx={{ alignItems: "center", justifyContent: "space-between" }}
            >
              <TextField
                variant="outlined"
                size="small"
                sx={{
                  height: "32px",
                  "& .MuiOutlinedInput-root": {
                    height: "32px",
                    backgroundColor: "white",
                    borderRadius: 0,
                  },
                  "& .MuiInputBase-root": {
                    paddingRight: "2px",
                  },
                  "& .MuiInputBase-input": {
                    paddingRight: "32px",
                  },
                }}
                placeholder="Search"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Stack color="primary" sx={{}}>
                        <SearchIcon
                          sx={{
                            backgroundColor: "#0a9a73",
                            color: "white",
                            padding: "2px",
                          }}
                        />
                      </Stack>
                    </InputAdornment>
                  ),
                }}
              />
              <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                    background: "white",
                    height: "30px",
                    borderRadius: "4px",
                    padding: "8px",
                    boxSizing: "border-box",
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={0.5}
                    sx={{ alignItems: "center" }}
                  >
                    <Typography sx={{ lineHeight: 1 }} variant="overline">
                      EN
                    </Typography>
                    <ExpandMoreIcon sx={{ stroke: 0.5 }} />
                  </Stack>
                  <Divider sx={{ mx: "4px" }} orientation="vertical" />
                  <Stack
                    direction="row"
                    spacing={0.5}
                    sx={{ alignItems: "center" }}
                  >
                    <Typography sx={{ lineHeight: 1 }} variant="overline">
                      USD
                    </Typography>
                    <ExpandMoreIcon />
                  </Stack>
                </Stack>
                <Button
                  variant="contained"
                  size="small"
                  sx={{ display: { xs: "none", sm: "block" } }}
                >
                  Login | Pay Bill
                </Button>
                <Tooltip title="Login | Pay Bill">
                  <IconButton
                    variant="contained"
                    size="large"
                    sx={{ color: "white", display: { xs: "flex", sm: "none" } }}
                  >
                    <AccountCircleIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Stack>
            <Nav />
            <Breadcrumb
              links={state.links}
              title={state.title}
            />
          </Box>
        </Stack>
        <Box sx={{ background: "white" }}>
          <Outlet />
        </Box>
      </Stack>
    </BreadcrumbContext.Provider>
  );
}

TopNavContainer.propTypes = {};

export default TopNavContainer;
